import { Component } from '@angular/core';

@Component({
    selector: 'app-capture-history-item-body',
    template: '<div><ng-content /></div>'
})
export class CaptureHistoryItemBodyComponent {}
